import UploadPage from "../features/upload/pages/uploadPage";
import { DashboardLayout } from "../layouts/DashboardLayout";

export default function Upload() {
  return (
    <DashboardLayout>
      <UploadPage />
    </DashboardLayout>
  )
}
